/* Namea – e-mail popup: vises efter et par sekunder (eller når musen forlader siden på desktop),
   aldrig på kurv/kasse, og ikke igen før efter X dage, hvis den lukkes. */
if (!customElements.get('namea-popup')) {
  customElements.define(
    'namea-popup',
    class NameaPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.key = 'namea-popup-hidden-until';
        this.querySelectorAll('[data-popup-close]').forEach((btn) => btn.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('cancel', () => this.remember());

        if (this.dataset.success === 'true') {
          this.remember(365);
        }
        if (this.dataset.openNow === 'true') {
          this.open();
          return;
        }
        if (!this.shouldShow()) return;

        const delay = Math.max(3, parseInt(this.dataset.delay || '12', 10)) * 1000;
        this.timer = window.setTimeout(() => this.open(), delay);
        this.onExit = (event) => {
          if (event.clientY <= 0) this.open();
        };
        if (window.matchMedia('(min-width: 990px)').matches) {
          document.addEventListener('mouseout', this.onExit);
        }
      }

      shouldShow() {
        if (['cart', 'password'].includes(this.dataset.template)) return false;
        if (window.Shopify && window.Shopify.designMode) return false;
        try {
          const until = parseInt(window.localStorage.getItem(this.key) || '0', 10);
          return Date.now() > until;
        } catch (error) {
          return true;
        }
      }

      remember(days) {
        const d = days || parseInt(this.dataset.days || '14', 10);
        try {
          window.localStorage.setItem(this.key, String(Date.now() + d * 86400000));
        } catch (error) {
          /* privat browsing: ignorer */
        }
      }

      open() {
        window.clearTimeout(this.timer);
        document.removeEventListener('mouseout', this.onExit);
        if (this.dialog.open) return;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
      }

      close() {
        this.remember();
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
      }
    }
  );
}
